// @see https://vuejs.org/v2/guide/reactivity.html#For-Objects
import {
  AddOperation,
  overrideArrOperation,
  overrideObjOperation,
  ReplaceOperation,
  restoreOriginalArrOperation,
  restoreOriginalObjOperation,
  isInteger,
  applyPatch
} from "fast-json-patch";
import Vue from "vue";
import { Operation } from "fast-json-patch/module/core";

export const applyPatchWithVueReactivity = <T>(
  document: T,
  patch: ReadonlyArray<Operation>
) => {
  overrideFastJsonPatchOps();
  applyPatch(document, patch);
  restoreFastJsonPatchOps();
};

export const restoreFastJsonPatchOps = () => {
  restoreOriginalObjOperation("remove");
  restoreOriginalObjOperation("add");

  restoreOriginalArrOperation("add");
  restoreOriginalArrOperation("replace");
  restoreOriginalArrOperation("remove");
};

export const overrideFastJsonPatchOps = () => {
  overrideObjOperation("remove", (obj, key, document) => {
    const removed = obj[key];
    Vue.delete(obj, key);
    return {
      newDocument: document,
      removed
    };
  });
  overrideObjOperation(
    "add",
    function (this: AddOperation<any>, obj, key, document) {
      Vue.set(obj, key, this.value);
      return { newDocument: document };
    }
  );

  // @see https://vuejs.org/v2/guide/reactivity.html#For-Arrays
  overrideArrOperation(
    "add",
    function (this: AddOperation<any>, arr, i, document) {
      if (isInteger(i)) {
        arr.splice(i, 0, this.value);
      } else {
        // array props
        Vue.set(arr, i, this.value);
      }
      // this may be needed when using '-' in an array
      return { newDocument: document, index: i };
    }
  );
  overrideArrOperation(
    "replace",
    function (this: ReplaceOperation<any>, arr, i, document) {
      const removed = arr[i];
      Vue.set(arr, i, this.value);
      return { newDocument: document, removed };
    }
  );

  overrideArrOperation(
    "remove",
    function (this: ReplaceOperation<any>, arr, i, document) {
      const removed = arr[i];
      Vue.delete(arr, i);
      return {
        newDocument: document,
        removed
      };
    }
  );
};
